import isMobileUser from 'TMUtils/isMobileUser';
// returns a string from arguments passed in depending on whether user is mobile or desktop
// mostly for testability purposes
export default (mobileString, desktopString) => {
    if (isMobileUser() || desktopString === '') {
        return mobileString;
    }
    return desktopString;
};
